import React from 'react';
// import SidebarLogo from '../../assets/SVGs/SidebarLogo';
import Burger from '../../assets/SVGs/Burger';
import { RootState } from '../../store';
import { useDispatch, useSelector } from 'react-redux';
import Cross from '../../assets/SVGs/Cross';
import { hideSideBar, openSideBar } from '../../store/sidebarSlice';
import { useAuthContext } from '../../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import { logoNameMap } from '../../assets/SVGs/logos/Logo';
import { isOvum } from '../../utils/utils';

const MobileHeader: React.FC = () => {
  const isOpen = useSelector((state: RootState) => state.sidebar.isOpen);
  const { isAuthenticated } = useAuthContext();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { theme } = useTheme();
  
  const sideButtonClickHandle = () => {
    isOpen ? dispatch(hideSideBar()) : dispatch(openSideBar());
  };

  const LogoCoponent = logoNameMap[theme.logo];
  
  // we don't need the mobile header for stluke
  if(theme.client === 'stluke' || theme.client === 'axis' || window.location.hostname.includes('axis')){
    return null;
  }

  // Hide the header in specific cases
  if (
    (!isAuthenticated && window.location.pathname === '/') || // Original condition
    location.pathname.includes('/linkpayment') || // Hide on payment page
    location.pathname.includes('/payments') || // Hide on payment page
    location.pathname.includes('/payment-history') || // Hide on payment history
    location.pathname.includes('/subscriptions') || // Hide on subscriptions
    location.pathname === '/' // Hide on home page for payments
  ) {
    return null;
  }

  return (
    <header className="bg-white px-4 py-3 flex justify-between items-center md:hidden">
      {/* Left Logo */}
      <div
        className="flex items-center cursor-pointer"
        onClick={() => { navigate('/');
        }}
      >
        <LogoCoponent width={153} id={'mobile'} />
      </div>

      {/* Right Menu Icon */}
      {isAuthenticated && (!isOvum() || window.location.pathname !== '/' ) && (
        <button
          onClick={sideButtonClickHandle}
          className="flex items-center justify-center w-10 h-10 bg-gray-10 rounded-lg shadow-sm"
        >
          {isOpen ? <Cross /> : <Burger />}
        </button>
      )}
    </header>
  );
};

export default MobileHeader;
